var map = {
	".": 2812,
	"./": 2812,
	"./App": 439,
	"./App.css": 4050,
	"./App.js": 439,
	"./assets/data/data": 1431,
	"./assets/data/data.jsx": 1431,
	"./assets/images/Programming-1.png": 9354,
	"./assets/images/angular.png": 3241,
	"./assets/images/bg_img.jpg": 1278,
	"./assets/images/class.jpg": 5691,
	"./assets/images/docker.png": 663,
	"./assets/images/footer-icon.png": 1646,
	"./assets/images/globe.webp": 9718,
	"./assets/images/interview.jpg": 3374,
	"./assets/images/kafka.png": 1425,
	"./assets/images/linkdin.png": 2794,
	"./assets/images/react.png": 5302,
	"./assets/images/resume.jpg": 5094,
	"./assets/images/spring-boot.png": 3115,
	"./assets/images/student/Amir.jpg": 3616,
	"./assets/images/student/Ankit_verma.jpg": 8616,
	"./assets/images/student/Arun_Gaur.jpg": 9417,
	"./assets/images/student/Arvind_Maurya.jpg": 1437,
	"./assets/images/student/Ashwini_Gupta.jpg": 7484,
	"./assets/images/student/Bhartendu_kumar.jpg": 4447,
	"./assets/images/student/Devesh.jpg": 60,
	"./assets/images/student/Javed_Khan.jpg": 8496,
	"./assets/images/student/Jitendra_Yadav.jpg": 5270,
	"./assets/images/student/Manoj_Saraswat.jpg": 4403,
	"./assets/images/student/Rahul_Singh.jpg": 2679,
	"./assets/images/student/Rahul_Sinha.jpg": 7611,
	"./assets/images/student/Saurabh_Singh.jpg": 9441,
	"./assets/images/student/Vikram_Singh.jpg": 7391,
	"./assets/images/student/noImg.png": 3357,
	"./assets/images/support.jpg": 4242,
	"./assets/images/tools/Frame1.png": 611,
	"./assets/images/tools/Frame10.png": 9899,
	"./assets/images/tools/Frame11.png": 9394,
	"./assets/images/tools/Frame12.png": 2329,
	"./assets/images/tools/Frame13.png": 6080,
	"./assets/images/tools/Frame14.png": 5103,
	"./assets/images/tools/Frame15.png": 9910,
	"./assets/images/tools/Frame16.png": 1117,
	"./assets/images/tools/Frame17.png": 9988,
	"./assets/images/tools/Frame18.png": 5907,
	"./assets/images/tools/Frame2.png": 5336,
	"./assets/images/tools/Frame3.png": 3201,
	"./assets/images/tools/Frame4.png": 2190,
	"./assets/images/tools/Frame5.png": 503,
	"./assets/images/tools/Frame6.png": 444,
	"./assets/images/tools/Frame7.png": 9541,
	"./assets/images/tools/Frame8.png": 386,
	"./assets/images/tools/Frame9.png": 4603,
	"./assets/images/tools/angular.png": 8949,
	"./assets/images/tools/fs.png": 1030,
	"./assets/images/tools/java.png": 5983,
	"./assets/images/tools/react.png": 7922,
	"./assets/images/tools/spring.png": 3848,
	"./assets/images/wave.png": 9696,
	"./component/TopHeader": 5679,
	"./component/TopHeader.css": 3045,
	"./component/TopHeader.jsx": 5679,
	"./index": 2812,
	"./index.js": 2812,
	"./service/Service": 4041,
	"./service/Service.jsx": 4041
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1407;